<div class="header">
    <span class="label">Bravo !</span>
    <span class="icon-close" (click)="closeDialog()"></span>
</div>
<mat-dialog-content class="assignment">
    <div class="content" *ngFor="let content of contentCompleted">
        <div class="icon" [ngClass]="getIcon(content)">
            <div class="icon-Valide"></div>
        </div>
        <div class="label">
            Vous avez terminé {{ getContentLevel(content) }} <b>{{ content.title }}</b>
        </div>
    </div>
    <div class="separator"></div>
    <div class="recommanded-activity" *ngIf="recommandedActivity">
        <div class="launch-button" (click)="launchContent($event)">
            <span style="width: 40px"></span>
            <span>Lancer l'activité suivante</span>
            <span class="icon-Lancer"></span>
        </div>
    </div>
</mat-dialog-content>
